import styled from 'styled-components/macro'
import { Box, MenuItem, TableContainer, TableRow } from '@material-ui/core'
import { ReactComponent as ContextIcon } from 'icons/more-horizontal.svg'
import { ReactComponent as ShareIcon } from 'icons/share-icon.svg'
import { ReactComponent as FilterIcon } from 'icons/filter-no-fill.svg'
import { ReactComponent as DeleteIcon } from 'icons/trash-icon.svg'
import { IconButton, Checkbox, Accordion, TableCell, TextField } from '@material-ui/core'
import { ReactComponent as FilterMenuIcon } from 'icons/filter-icon-search.svg'
import { Button } from 'common/atoms/Button/Button'

export const EventBanner = styled(Box)`
  width: 100%;
  background-image: url('/pages/event/images/Hero.png');
`

export const StyledContextIcon = styled(ContextIcon)`
  && {
    height: 0.6em;
    color: ${props => props.theme.colors.accent1};
    padding: 0px;
  }
`
export const StyledEditIcon = styled(ShareIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
    width: 0.8em;
    height: 0.8em;
  }
`

export const StyledFilterIcon = styled(FilterIcon)`
  transform: scale(0.8);
  stroke: ${props => props.theme.colors.accent1};
`
export const StyledAccordionDetailItem = styled(Box)`
  && {
    color: ${props => props.theme.colors.accent1};
    font-weight: bold;
    width: 100%;
    :hover,
    :active,
    :visited {
      background-color: transparent;
    }
  }
`
export const StyledCheckBox = styled(Checkbox)`
  && {
  }
`
export const StyledMenuItem = styled(Accordion)`
  .muiaccordion-rounded: {
    border-radius: '0px',
    box-shadow: 'none'
  }
  && {
    background-color: ${props => props.theme.colors.backgroundComplementIII};
    width: 100%;
    border-radius: 0;
  }
`
export const StyledPill = styled(Box)`
  && {
    color: ${props => props.theme.colors.accent1};
    font-weight: bold;
    border: 1.26px solid #5f5f5f;

    :hover {
      background-color: transparent;
      color: transparent;
    }
  }
`
export const RoundedBox = styled(Box)`
  && {
    background-color: ${props => props.theme.colors.supplementary};
    height: 2rem;
    width: 2rem;
    border-radius: 50%;
    font-size: 1.5rem;
  }
`
export const MenuHeader = styled(Box)`
  && {
    width: 100%;
  }
`

export const StyledFooterButtonOutlined = styled(Button)`
  && {
    padding: 0.1em 0.5em;
    border: 2px solid ${props => props.theme.colors.primary};
    border-radius: 20px;
    color: ${props => props.theme.colors.accent1};
    background-color: inherit;
  }
`

export const RegistrantsListSearch = styled(Box)`
  && {
    background-color: ${props => props.theme.colors.supplementary};
    border-radius: 5.125em;
    margin: 1em 1em 1em 0;
    height: 2.5em;
    width: 19vw;
  }
`

export const StyledFilterMenuIcon = styled(FilterMenuIcon)`
  && {
    transform: scale(0.75);
    fill: ${props => props.theme.colors.primary};
  }
`
export const StyledDeleteIcon = styled(DeleteIcon)`
  && {
    fill: ${props => props.theme.colors.error};
    width: 0.8em;
    height: 0.8em;
    margin-right: 1em;
    cursor: pointer;
  }
`

export const StyledHeadTableCell = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent};
    background-color: ${props => props.theme.colors.supplementary1};
    border-bottom-color: ${props => props.theme.colors.supplementary};
    border-width: 3;
  }
`
export const StyledTableCell = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent1};
    background-color: ${props => props.theme.colors.supplementary1};
    border-bottom-color: ${props => props.theme.colors.supplementary};
    border-width: 3;
    cursor: pointer;

    & .MuiPopover-paper {
      min-width: 0px !important;
    }
  }
`
export const StyledTableCellStatus = styled(Button)`
  && {
    color: ${props => props.theme.colors.accent1};
    font-weight: bold;
    border-radius: 1.5em;
    border-color: ${props => props.theme.colors.accent1};
    border-width: 1px;
    height: 32px;
    cursor: pointer;
    text-transform: capitalize;
  }
`
export const SearchInput = styled(TextField)`
  & .MuiInput-input {
    background: no-repeat;
  }
  & .MuiInputBase-root {
    padding: 0em;
    bottom: 0.25em;
  }

  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }
`

export const StyledDateBox = styled(Box)`
  && {
    /* border-radius: 5.125em !important; */

    & .makeStyles-select-798 {
      background-color: red;
    }
  }
`

export const StyledIconButton = styled(IconButton)`
  && {
    .MuiTypography-root {
      color: ${props => props.theme.colors.accent1};
      line-height: 1em;
      font-weight: bold;
      font-size: 12px;
      padding: 0px;
    }
  }
`

export const CustomMenuItem = styled(MenuItem)`
&&{
  padding: 0;
  border-radius: 10px;
}
`

export const ResetButton = styled(Box)`
  cursor: pointer;
  text-decoration: underline; 
  font-weight: bolder;
`

export const CustomTableContainer = styled(TableContainer)<{ showFilter: boolean }>`
  height: ${({ showFilter }) => (!showFilter ? '60vh' : '100vh')};
  border-radius: 5px;
  overflow: hidden;
`

export const CustomTableRow = styled(TableRow)`
  border: 0;
`
